export function selectMentionsForSend<T>({
  isChatWindowActive,
  liveMentions,
  chatTabMentions,
}: {
  isChatWindowActive: boolean;
  liveMentions: T[];
  chatTabMentions: T[];
}): T[] {
  return isChatWindowActive ? liveMentions : chatTabMentions;
}

export function composerContextAfterSend({
  isChatWindowActive,
}: {
  isChatWindowActive: boolean;
}): { clearLiveMentions: boolean; clearTabMentions: true } {
  return {
    clearLiveMentions: isChatWindowActive,
    clearTabMentions: true,
  };
}

export function shouldMarkComposerMentionsCleared({
  selectedMentionsKey,
  previousMentionsKey,
  storeMentionsKey,
}: {
  selectedMentionsKey: string;
  previousMentionsKey: string | null;
  storeMentionsKey: string;
}): boolean {
  return (
    selectedMentionsKey === '[]' &&
    previousMentionsKey !== null &&
    previousMentionsKey !== '[]' &&
    storeMentionsKey !== '[]'
  );
}

export function shouldSkipStoreMentionsSync({
  clearedLocally,
  tabChanged,
  storeMentionsKey,
}: {
  clearedLocally: boolean;
  tabChanged: boolean;
  storeMentionsKey: string;
}): boolean {
  if (tabChanged || storeMentionsKey === '[]') {
    return false;
  }

  return clearedLocally;
}
